import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import { PendingWithdrawalsViewModule } from '@modules/pending-withdrawals/submodules/view/PendingWithdrawalsViewModule';
import {
  ADMIN_PARTNERS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_PENDING_WITHDRAWALS_LIST_ROUTE_NAME,
  ADMIN_PENDING_WITHDRAWALS_ROUTE_NAME,
  PENDING_WITHDRAWALS_PERMISSIONS,
  TRANSLATION_GROUP_PENDING_WITHDRAWALS,
} from './constants';
import { getTranslationKeys } from './translations';

export class PendingWithdrawalsModule extends AppModule {
  protected submodules = [
    new PendingWithdrawalsViewModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_PENDING_WITHDRAWALS_ROUTE_NAME,
      path: 'pending-withdrawals',
      permission: PENDING_WITHDRAWALS_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'PendingWithdrawalsListPage',
    });

    router.addChildRoute(ADMIN_PENDING_WITHDRAWALS_ROUTE_NAME, {
      name: ADMIN_PENDING_WITHDRAWALS_LIST_ROUTE_NAME,
      path: '',
      permission: PENDING_WITHDRAWALS_PERMISSIONS.SHOW,
      component: () => import('./pages/PendingWithdrawalsListPage/PendingWithdrawalsListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'PARTNERS_PENDING_WITHDRAWALS'),
      to: {
        name: ADMIN_PENDING_WITHDRAWALS_LIST_ROUTE_NAME,
      },
      permission: PENDING_WITHDRAWALS_PERMISSIONS.SHOW,
      id: ADMIN_PENDING_WITHDRAWALS_LIST_ROUTE_NAME,
      order: 120,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_PENDING_WITHDRAWALS, getTranslationKeys);
  }
}
